import { EntitiesVersionApi, EntityVersion } from 'core/types/entity.types';
import { admGraphqlRequest, aomGraphqlRequest, globalGraphqlRequest } from 'core/utils/backend-service';
import { isReplicated } from './entities-version.queries';

export const checkGlobalEntitiesVersion = async (entities: EntityVersion[]): Promise<EntitiesVersionApi> =>
    globalGraphqlRequest(isReplicated(), { entities }).then((result) => result.data.checkEntitiesVersion);

export const checkAomEntitiesVersion = async (entities: EntityVersion[]): Promise<EntitiesVersionApi> =>
    aomGraphqlRequest(isReplicated(), { entities }).then((result) => result.data.checkEntitiesVersion);

export const checkAdmEntitiesVersion = async (entities: EntityVersion[]): Promise<EntitiesVersionApi> =>
    admGraphqlRequest(isReplicated(), { entities }).then((result) => result.data.checkEntitiesVersion);
